import { render, staticRenderFns } from "./NmtSidebarProfileChartDialogChip.vue?vue&type=template&id=5b417871&scoped=true&"
import script from "./NmtSidebarProfileChartDialogChip.vue?vue&type=script&lang=js&"
export * from "./NmtSidebarProfileChartDialogChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b417871",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
